import PropTypes from 'prop-types';

export const perspectiveShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  getSeriesName: PropTypes.func.isRequired,
  getSeriesColor: PropTypes.func.isRequired,
  getMonthlyExtraData: PropTypes.func,
});
